import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { StsRecaptchaService } from 'app/services/sts-recaptcha.service';
import { StsNotification } from 'app/models/sts-notification.model';
import { StsNotificationType } from 'app/models/sts-notification-type';
import { StsCaptcha } from 'app/models/sts-captcha.model';

@Component({
  selector: 'app-sts-recaptcha',
  templateUrl: './sts-recaptcha.component.html'
})
export class StsRecaptchaComponent implements OnInit {
  @Output() onValidate: EventEmitter<any> = new EventEmitter();
  private recaptchaResponse: string = null;
  public loaded = false;
  public siteKey: string; // '6LfedhUUAAAAAPiMsBZItrGZhkypFBGUheQbU0Z5';

  constructor(private recaptchaService: StsRecaptchaService) { }

  ngOnInit() {
    this.recaptchaService.getRecaptchaSiteKey().subscribe(d => {
      this.siteKey = d.siteKey;
      this.loaded = true;
    });
  }

  resolved(response: string) {
    this.recaptchaResponse = response;
  }

  public reset() {}

  public submit() {
    let capchaObj: StsCaptcha = {
      recaptchaResponse: this.recaptchaResponse
    };

    this.onValidate.emit(capchaObj);
  }

  public checkForCaptchaError(captcha: StsCaptcha) {
    if (this.recaptchaResponse) {
      return null;
    } else {
      let err = new StsNotification();
      err.code = 'sts-captcha-invalid';
      err.description = 'Sorry, we couldn\'t verify your captcha response';
      err.level = StsNotificationType.Error;
      return err;
    }
  }
}
